var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Calendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.625H17.625V3.25C17.625 2.95163 17.5065 2.66548 17.2955 2.4545C17.0845 2.24353 16.7984 2.125 16.5 2.125C16.2016 2.125 15.9155 2.24353 15.7045 2.4545C15.4935 2.66548 15.375 2.95163 15.375 3.25V3.625H8.625V3.25C8.625 2.95163 8.50647 2.66548 8.2955 2.4545C8.08452 2.24353 7.79837 2.125 7.5 2.125C7.20163 2.125 6.91548 2.24353 6.7045 2.4545C6.49353 2.66548 6.375 2.95163 6.375 3.25V3.625H4.5C4.00272 3.625 3.52581 3.82254 3.17417 4.17417C2.82254 4.52581 2.625 5.00272 2.625 5.5V19.5C2.625 19.9973 2.82254 20.4742 3.17417 20.8258C3.52581 21.1775 4.00272 21.375 4.5 21.375H19.5C19.9973 21.375 20.4742 21.1775 20.8258 20.8258C21.1775 20.4742 21.375 19.9973 21.375 19.5V5.5C21.375 5.00272 21.1775 4.52581 20.8258 4.17417C20.4742 3.82254 19.9973 3.625 19.5 3.625ZM19.125 5.875V8.125H4.875V5.875C9.91892 5.875 14.9742 5.875 19.125 5.875ZM4.875 19.125V10.375H19.125V19.125H4.875Z",
    fill: "#6B7380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Calendar);
export default __webpack_public_path__ + "static/media/24_calendar.2e03d51ad0c90789f440df36da7d22bd.svg";
export { ForwardRef as ReactComponent };